/*
*	Details list model
*/
function SLR_DetailsList(_dl)
{
	/* Properties */
	var self = this;
	self.dl = _dl;
	self.details = [];

	/* Methods */
	self.getDetailsItem = function(item_id)
	{
		var item = false;
		self.details.forEach(function(x){
			if (x.model.item.id == item_id){
				item = x;
			}
		});
		return item;
	};

	self.addDetailsItem = function(details_item)
	{
		details_item.model.item.list_order = self.details.length + 1;
		self.details.push(details_item);
	};

	self.removeDetailsItem = function(details_item)
	{
		var index = self.details.indexOf(details_item);
		if (index >= 0){
			self.details.splice(index, 1);
		}
	};

	self.duplicateDetailsItem = function(item)
	{
		// gather data
		var request = new FormData(),
			data = {};

		// build request
		request.append("model", "detailsitem");
		request.append("action", "duplicate");
		request.append("data", JSON.stringify(item.model.item));

		// add request to queue
		$.slr.db.add(request, function(x)
		{
			var invoice_type = self.dl.details_tab.e.el.form.get_invoice_type();
			self.dl.load_details_item(invoice_type, x.item.id);
		});
		return false;
	};

	self.setListOrder = function(list_order)
	{
		// gather data
		var request = new FormData(),
			data = {};

		// new details array
		var newDetailsList = [];
		for (var i = 0; i < list_order.length; i++) {
			var detailsItem = self.getDetailsItem(list_order[i]);
			detailsItem.model.item.list_order = i+1;
			newDetailsList.push(detailsItem);
		}
		self.details = newDetailsList;

		// build request
		request.append("model", "detailsitem");
		request.append("action", "order");
		request.append("data", JSON.stringify(list_order));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	self.getCount = function()
	{
		return self.details.length;
	};

	self.each = function(callback)
	{
		self.details.forEach(function(x){
			callback(x);
		});
	};
}

/*
*	Details list interface behavior
*/
$.fn.DetailsList = function(_details_tab)
{
	var _dl = this;
	_dl.model = new SLR_DetailsList(_dl);
	_dl.template = undefined;
	_dl.details_tab = _details_tab;
	_dl.interface = {
		add_button : _dl.find(".btn-action-add-details"),
		container : _dl.find(".slr-details-item-container"),
		cell_received : _dl.find(".cell-subtotal-received"),
		cell_due : _dl.find(".cell-subtotal-due")
	};

	_dl.refresh = function()
	{
		// show elements
		_dl.model.each(function(x){
			_dl.interface.container.append(x);
		});

		// update details and totals
		_dl.details_tab.e.updateDetailsSummary();
		_dl.updateTotals();
	};

	_dl.add_details = function()
	{
		var newDetailsItem = _dl.template.find(".slr-item").clone();
		newDetailsItem.DetailsItem(_dl);
		newDetailsItem.save();
		_dl.model.addDetailsItem(newDetailsItem);
		_dl.refresh();
		return false;
	};

	_dl.remove_details_item = function(item)
	{
		_dl.model.removeDetailsItem(item);
		_dl.refresh();
		_dl.updateRights();
	};

	_dl.duplicate_details_item = function(item)
	{
		_dl.model.duplicateDetailsItem(item);
	}

	_dl.load_details_item = function(invoice_type, item_id)
	{
		$.get("/facture/details_item/" + invoice_type + "/" + item_id, {}, function(x){
			var newDetailsItem = $($(x)[0]);
			newDetailsItem.DetailsItem(_dl);
			_dl.model.addDetailsItem(newDetailsItem);
			_dl.refresh();
			_dl.updateRights();
		}, 'html');
	};

	_dl.details_items_sorted = function(e)
	{
		var order = [];
		_dl.interface.container.find(".slr-item").each(function(index, el){
			order.push(parseInt($(el).find("input[name=details_item_id]").val(), 10));
		});
		_dl.model.setListOrder(order);
		_dl.details_tab.e.updateDetailsSummary();
	};

	_dl.setElementID = function(elementID)
	{
		// show elements
		_dl.model.each(function(x){
			if (x.model.item.element_id == undefined){
				x.set("element_id", elementID);
			}
		});
	};

	_dl.updateTotals = function()
	{
		var subtotal_base = 0,
			subtotal_due = 0;
		_dl.model.details.forEach(function(x){
			subtotal_base += x.model.getBase();
			subtotal_due += x.model.getDue();
		});
		var subtotal_base = subtotal_base.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}),
			subtotal_due = subtotal_due.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		_dl.interface.cell_received.html(subtotal_base);
		_dl.interface.cell_due.html(subtotal_due);
	};

	_dl.updatedBaseFee = function()
	{
		_dl.model.details.forEach(function(x){
			x.update();
			x.model.save();
		});
	};
	
	_dl.updateRights = function()
	{
		_dl.model.details.forEach(function(x){
			if (x.getItemType() == "DROITS") {
				x.update();
				x.model.save();
			}
		});
	};
	
	_dl.getRights = function()
	{
		var rights_total = 0;
		_dl.model.each(function(item) {
			rights_total += item.calc.rights();
		});
		return rights_total;
	};

	return function()
	{
		_dl.template = _dl.find("#slr-item-template").clone().removeAttr("id");
		_dl.find("#slr-item-template").remove();
		_dl.interface.add_button.on("click", function(){
			_dl.add_details();
			// focus sur le champ Détails de la nouvelle ligne
			_dl.interface.container.find(".slr-item").last().find(".select2-selection").first().focus();
			return false;
		});

		// loaded items
		var loadedItems = _dl.interface.container.find(".slr-item");
		if (loadedItems.length){
			loadedItems.each(function(){
				var loadedElement = $(this).DetailsItem(_dl);
				_dl.model.addDetailsItem(loadedElement);
			});
			_dl.refresh();
		} else {
			_dl.add_details();
		}

		// sortable
		_dl.find(".slr-details-item-container").sortable({
			helper : 'clone',
			stop : _dl.details_items_sorted,
			handle : '.drag-item-button'
		});
		_dl.on("mousedown", function(e){
			if (e.target.nodeName.toLowerCase() != "input"){
				_dl.find("input").blur();
			}
		});
		return _dl;
	}();
};
